import Loading from '@/shared/components/Carregando';
import ProfileHomeCard from '@/modules/home/components/ProfileHomeCard';
import { getProfileHomeItems } from '@/modules/home/profile-home.utils';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { useMemo } from 'react';

export default function ProfileHomePage() {
  const { effectiveView, viewLabel, viewReady, permissions } =
    useNavigationView();

  const items = useMemo(() => {
    if (effectiveView == null) return [];
    return getProfileHomeItems(effectiveView, permissions);
  }, [effectiveView, permissions]);

  if (!viewReady || effectiveView == null) {
    return <Loading />;
  }

  return (
    <div className="container py-4">
      <section className="text-center mb-4">
        <h2 className="mt-1 mb-1" style={{ color: '#1f2d24', fontWeight: 700 }}>
          {viewLabel}
        </h2>
        <div className="text-muted" style={{ maxWidth: 860, margin: '0 auto' }}>
          Selecione abaixo a área do sistema que deseja acessar nesta sessão.
        </div>
      </section>

      <div className="escolha-modulo-wrap escolha-modulo-wrap--profile-home">
        <ul className="escolha-modulo-grid escolha-modulo-grid--3cols">
          {items.map((item) => (
            <li key={`${item.label}-${item.to}`}>
              <ProfileHomeCard
                label={item.label}
                description={item.description}
                to={item.to}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
